const announcementsFR = {
    "view": {
        "dropdown": {
            "unreadHeading": "{{count}} annonces non lues",
            "empty": "Aucune annonce",
            "newBadge": "Nouveau",
            "dismissAll": "Tout ignorer",
        },
        "modal": {
            "defaultTitle": "Annonce",
        },
        "table": {
            "title": "Annonces",
            "column": {
                "title": "Titre",
                "datePosted": "Date de publication",
                "dismissed": "Ignoré",
                "status": "Statut",
                "action": "Action",
            },
            "status": {
                "read": "Lu",
                "unread": "Non lu",
            },
            "csv": {
                "statusRead": "Lu",
                "statusUnread": "Non lu",
                "dismissedYes": "Ignoré",
                "dismissedNo": "Non ignoré",
            },
            "action": {
                "view": "Voir",
            },
            "button": {
                "exportCsv": "Exporter le CSV",
            },
        },
    },
};

export default announcementsFR;
